import http from './http'

export default {
  getList: params => http.get('/v2/horses', { params }),
  options: params => http.get('/v2/horses/options', { params }),
  search: q => http.get('/v2/horses/search', { params: { q } }),
  previewMerge: data => http.post('/v2/horse-merges/preview', data, { silent: true, localSuccess: true }),
  merge: data => http.post('/v2/horse-merges', data, { silent: true, localSuccess: true })
}



// WEBPACK FOOTER //
// ./src/services/api/horses.js